import { render } from "./OneClick.vue?vue&type=template&id=b39361b4&scoped=true"
import script from "./OneClick.vue?vue&type=script&lang=js"
export * from "./OneClick.vue?vue&type=script&lang=js"

import "./OneClick.vue?vue&type=style&index=0&id=b39361b4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39361b4"]])

export default __exports__